import { PluginKey } from '@atlaskit/editor-prosemirror/state';
export var codeBidiWarningPluginKey = new PluginKey('codeBidiWarningPlugin');